module.exports = __webpack_public_path__ + "img/bree-3018-10-01.a9b660c0.jpg";